import getPlanTypeKey from 'core/controllerPlans/getPlanTypeKey'
import saveToStorage from 'core/controllerPlans/saveToStorage'
import { FILTER_CHANGED } from 'messages'
import toastNotification from 'pug/toastNotification'
import updateAddons from 'sites/pivothealth.com/fixed-benefit-medical/consumer/quotes/utils/updateAddons'
import querySelectorAll from 'utils/DOM/querySelectorAll'
import store from 'utils/store/withMiddleware'
import applyRules from '../controller/applyRules'
import renderPlanFilters from '../renderPlanFilters'
import fitPlanConfigurationForFilter from '../utils/fitPlanConfigurationForFilter'
import getTemplate from '../utils/getTemplate'
import { renderMultiCarrierPlan, renderPlan } from '../utils/renderPlans'
const templatePlan = getTemplate('template-plan')

function updateOption() {
  const name = this.name
  const { filtersByProductType, plans } = store.getState()
  const multiCarrierPlans = Object.entries(plans)
    .map(entry => entry[1])
    .filter(plan => plan?.multiCarrierPlan)

  // Get all the deductibles for multi-carrier plans
  const deductibles = multiCarrierPlans.map(plan => plan.coreBenefits.deductible)
  const dedupedDeductibles = deductibles.filter(
    (value, index) => deductibles.indexOf(value) === index && value
  )

  // Get all the max out of pockets for multi-carrier plans
  const moops = multiCarrierPlans.map(plan => plan.coreBenefits.outOfPocketMax)
  const dedupedMoops = moops.filter(
    (value, index) => moops.indexOf(value) === index && value
  )

  // Get all the coinsurances for multi-carrier plans
  const coinsuranceOptions = multiCarrierPlans.map(
    plan => plan.coreBenefits.userCoinsurance
  )
  const dedupedCoinsurances = coinsuranceOptions.filter(
    (value, index) => coinsuranceOptions.indexOf(value) === index && value
  )

  // Get all lifetime maximums for multi-carrier plans

  const lifetimeMaxiumums = multiCarrierPlans.map(plan => plan.coreBenefits.lifetimeMax)
  const dedupedMaximums = lifetimeMaxiumums.filter(
    (value, index) => lifetimeMaxiumums.indexOf(value) === index && value
  )

  filtersByProductType.multi = {
    coinsurance: {
      type: 'one',
      values: dedupedCoinsurances
    },
    coverage: {
      type: 'one',
      values: dedupedMaximums.map(max => parseInt(max))
    },
    deductible: {
      type: 'one',
      values: dedupedDeductibles.map(deductible => parseInt(deductible))
    },
    moop: {
      type: 'one',
      values: dedupedMoops.map(moop => parseInt(moop))
    }
  }

  const [planId, filterName] = name.split('-')

  const planTypeKey = getPlanTypeKey(plans[planId])

  const planConfiguration = fitPlanConfigurationForFilter({
    planTypeKey,
    filters: [{ filterName, filterValue: this.value }],
    filtersByProductType
  })
  filtersByProductType[planTypeKey] = planConfiguration.planFilter

  const state = store.getState()
  const newState = applyRules({ ...state, filtersByProductType })
  saveToStorage(newState)
  store.update(newState, true)

  const plan = state.plans[planId]

  const isMultiCarrier = plan?.multiCarrierPlan

  let newPlanId

  const container = querySelectorAll(`div[data-type="${planTypeKey}"]`)

  if (!isMultiCarrier) {
    newPlanId = planConfiguration.alternativePlanId || planId

    const newPlan = renderPlan(templatePlan, newPlanId, newState, 0, false)

    const newElement = document.createElement('div')

    newElement.innerHTML = newPlan

    container[0].replaceWith(newElement.firstChild)
  } else {
    if (filterName === 'deductible') {
      const planWithMatchingDeductible = multiCarrierPlans.find(
        plan => plan.coreBenefits.deductible === this.value
      )
      newPlanId = planWithMatchingDeductible.planId
    }

    if (filterName === 'moop') {
      const plansWithMatchingMoop = multiCarrierPlans.find(
        plan => plan.coreBenefits.outOfPocketMax === this.value
      )
      newPlanId = plansWithMatchingMoop.planId
    }

    if (filterName === 'coverage') {
      const plansWithMatchingMax = multiCarrierPlans.find(
        plan => plan.coreBenefits.lifetimeMax === this.value
      )
      newPlanId = plansWithMatchingMax.planId
    }

    if (filterName === 'coinsurance') {
      const plansWithMatchingCoinsurance = multiCarrierPlans.find(
        plan => plan.coreBenefits.userCoinsurance === this.value
      )
      newPlanId = plansWithMatchingCoinsurance.planId
    }

    const templateMultiCarrierPlan = getTemplate('template-multi-carrier-plan')
    const newPlan = renderMultiCarrierPlan(
      templateMultiCarrierPlan,
      multiCarrierPlans,
      state,
      newPlanId
    )

    const newElement = document.createElement('div')
    newElement.innerHTML = newPlan

    container[0].replaceWith(newElement)
  }

  renderPlanFilters(
    [newPlanId],
    newState.plans,
    newState.filterOptionsByProductType,
    newState.filtersByProductType,
    newState,
    isMultiCarrier
  )

  updateAddons(newState)

  if (planConfiguration.hasForceFilterChange) {
    toastNotification(FILTER_CHANGED, 2500)
  }
}

export default updateOption
